import { Component, OnInit, TemplateRef } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService, NzModalRef } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { AuthService } from '../auth/auth.service';
import { VouchersSearch } from '../models/voucher';
import { UserTypes } from '../utilities/common-file';
import { NzTableData } from '../utilities/nz-table.adapter';
import { VouchersService } from './vouchers.service';

@Component({
  selector: 'app-vouchers',
  templateUrl: './vouchers.component.html',
  styleUrls: ['./vouchers.component.less']
})
export class VouchersComponent implements OnInit {
  voucherCode: any;
  locationsList: any;
  locationId: any;
  errorMessage: string;
  validateLoading: boolean;
  voucherCodeModal: NzModalRef;
  loginUserType: string;
  locationListShow: boolean;
  userRole=UserTypes;
  locationData:any;
  deviceSignature = '';

  private tableData: NzTableData<VouchersSearch, any> = new NzTableData<VouchersSearch, any>(new VouchersSearch(), 'fullName', );


  constructor(    
    private voucherService: VouchersService,
    private modalService: NzModalService,
    private notification: NzNotificationService,
    private authService: AuthService,
    private message: NzMessageService) { }

  ngOnInit() {
    this.loginUserType = this.authService.getRole();
    this.tableData.search.merchantId = this.authService.getMerchantId();
    if (this.loginUserType === this.userRole.merchant) {
      this.locationListShow = true;
      this.locationsList = this.authService.getLocationDetails();
    } else {
      this.locationListShow = false;
      this.tableData.search.locationId = '';
      this.locationId = this.authService.getLocationId();
    }
    this.deviceSignature = this.authService.getDeviceSignature();
  }

  getModuleGroupAndModuleAccess(moduleName: string, groupName: string) {
    return this.authService.getModuleGroupAndModuleAccess(moduleName, groupName);
}


  // Modal Pop up 
  voucherCodeModalPopup(
    Title: TemplateRef<{}>,
    Content: TemplateRef<{}>,
    Footer: TemplateRef<{}>
  ) {

    this.voucherCodeModal = this.modalService.create({
      nzTitle: Title,
      nzContent: Content,
      nzFooter: Footer,
      nzMaskClosable: false,
      nzClosable: false,
      nzWidth: '35%',
      nzOnOk: () => console.log('Click ok'),
    });
  }

  validateVoucher() {
    if (this.voucherCode) {
      if (this.locationsList) {
        if (this.locationId) {
          this.errorMessage = '';
          this.validateLoading = true;
          const args = {
            voucherCode: this.voucherCode
          }
          this.voucherService.validateVoucher(args).subscribe((response: any) => {
            if (response.success) {
              this.locationData = 'locationList';

              this.redeemVoucher('locationList');
              this.errorMessage = '';
            } else {
              this.errorMessage = response.message;
              this.validateLoading = false;
            }
          }, (err) => {
            this.validateLoading = false;
          });
        }
        else {
          this.validateLoading = false;
          this.notification.error('Please select location', '', {
            nzKey: 'key'
          });
        }

      }
      else {
        this.errorMessage = '';
        this.validateLoading = true;
        const args = {
          voucherCode: this.voucherCode
        }
        this.voucherService.validateVoucher(args).subscribe((response: any) => {
          if (response.success) {
            this.locationData = 'locationId';
            this.redeemVoucher('locationId');
            this.errorMessage = '';
          } else {
            this.errorMessage = response.message;
            this.validateLoading = false;
          }
        }, (err) => {
          this.validateLoading = false;
        });
      }
    }
    else {
      this.validateLoading = false;
      this.notification.error('Please enter voucher code', '', {
        nzKey: 'key'
      });
    }

  }

  redeemVoucher(locationData) {
    this.validateLoading = true;
    const args = {
      voucherCode: this.voucherCode,
      merchantId: this.authService.getMerchantId(),
      locationId: this.locationId,
      deviceSignature: this.deviceSignature
    }
    this.voucherService.redeeemVoucher(args).subscribe((response: any) => {
      this.validateLoading = false;
      if (response.success) {
        this.errorMessage = '';
        this.voucherCode = '';
        if(locationData == 'locationList'){
          this.locationId = '';
        }
        this.message.create('success', response.message);
        this.close();
      } else {
        this.errorMessage = response.message;
        this.validateLoading = false;
      }
    }, (err) => {
      this.validateLoading = false;
    });
  }

  clearSearch() {
    this.voucherCode = '';
  }

  close() {
    this.voucherCode = '';
    if(this.locationData == 'locationList'){
      this.locationId = '';
    }
    this.voucherCodeModal.close();
  }


}
